import { reactive } from 'vue';
import Api from '../api/PracticeDriving';
import BaseRequest from "../api/BaseRequest";
let map = null;

const state = reactive({
    isLoading: true,
    isMapLoading: true,
    isDeleting: false,
    route: {
        id: null,
        name: '',
        duration: '',
        createdAt: '',
        distanceInKm: null,
        coordinates: [],
    },
    mapOptions: {
        zoom: 12,
        center: {lat: 59.9185, lng: 10.7937,},
        mapId: window.env.GOOGLE_MAPS_MAP_ID ?? '',
        mapTypeControl: false,
    },
    apiKey: window.env.GOOGLE_MAPS_API_KEY ?? '',
    placeIdArray: [],
    polylines: [],
    snappedCoordinates: [],
    snapMapApiResponse: [],
    apiRequests: 0,
    apiRequestsCompleted: 0,
    markers: [],
    errorMessage: null,
});

function init(routeId) {
    Api.GetCoordinates(routeId).then(res => {
        state.isLoading = false;
        if (res.success) {
            setRoute(res.data.route);
            state.isMapLoading = false;
        } else if (res.message) {
            state.isMapLoading = false;
            state.errorMessage = res.message
        }
    }).catch(e => {
        console.error(e)
        state.isMapLoading = false
        state.isLoading = false;
        state.errorMessage = $t('Det skjedde noe galt. Prøv igjen senere.')
    });
}

function setRoute(route) {
    state.route.id = route.id;
    state.route.name = route.name;
    state.route.distanceInKm = route.distance_in_km;
    state.route.coordinates = route.coordinates;
    state.route.duration = route.duration;
    state.route.createdAt = route.formattedCreatedAt;
    state.route.cachedApiResults = route.cached_api_results ?? null;
}

function cacheApiResponse (batchNumber) {
    if (typeof state.snapMapApiResponse[batchNumber] === 'undefined') {
        return; // Done - no more batches to upload
    }
    const dataToStore = state.snapMapApiResponse[batchNumber].map(function(dataset) {
        return {lat: dataset.location.latitude.toFixed(7), lng: dataset.location.longitude.toFixed(7)};
    })
    storeApiResponse(batchNumber, dataToStore);
}

function storeApiResponse (batchNumber, data) {
    console.log('storeApiResponse', state.route.id, batchNumber);
    Api.cacheRoadsApiResponse(state.route.id, batchNumber, data).then(res => {
        if (res.success) {
            cacheApiResponse((batchNumber - 1))
            return ;
        }

        console.log('error')
    });
}

function getRoute() {
    return state.route;
}

function isLoading() {
    return state.isLoading;
}

function isDeleting() {
    return state.isDeleting;
}

function isMapLoading() {
    return state.isMapLoading;
}

async function initMap(mapEl) {
    const { Map } = await google.maps.importLibrary("maps");
    map = new Map(mapEl, state.mapOptions);
    selectPracticeDrive();
}

// Store snapped polyline returned by the snap-to-road service.
async function processSnapToRoadResponse(data) {
    const { LatLng } = await google.maps.importLibrary("core")
    state.snappedCoordinates = [];
    state.placeIdArray = [];
    for (var i = 0; i < data.length; i++) {
        var latlng = new LatLng(
            data[i].location.latitude,
            data[i].location.longitude);
        state.snappedCoordinates.push(latlng);
        state.placeIdArray.push(data[i].placeId);
    }
}

// Draws the snapped polyline (after processing snap-to-road response).
async function drawSnappedPolyline() {
    const { Polyline } = await google.maps.importLibrary("maps");

    var snappedPolyline = new Polyline({
        path: state.snappedCoordinates,
        strokeColor: '#253858',
        strokeWeight: 4,
        strokeOpacity: 0.9,
    });

    snappedPolyline.setMap(map);
    state.polylines.push(snappedPolyline);
}

function getLinesFromApi(pathValues, index) {
    state.apiRequests++;
    BaseRequest.Get('https://roads.googleapis.com/v1/snapToRoads', {
        interpolate: true,
        key: state.apiKey,
        path: pathValues.join('|')
    }, false).then(data => {
        aggregateResponse(data, index);
    });
}

function aggregateResponse (data, index) {
    console.log('added batch ' + index + ' to snapMapApiResponse')
    state.snapMapApiResponse[index] = data.snappedPoints

    state.apiRequestsCompleted++;
    console.log('Number of complete api requests: ' + state.apiRequestsCompleted);
}

function selectPracticeDrive() {
    const coordinates = state.route.coordinates;
    const cachedApiResponse = state.route.cachedApiResults
    let pathValues = [];
    let arrLat = [];
    let arrLng = [];
    let currLat, currLng;

    if (Array.isArray(cachedApiResponse) && cachedApiResponse.length > 0 && cachedApiResponse[0].batch_number === 0) {
        // We have cached Roads API result.
        console.log('Using cached Roads API result');
        drawCachedRoadsResponse(cachedApiResponse);
        return;
    }

    console.log('NOT CACHED: Roads API result');
    for (var i = 0; i < coordinates.length; i++) {
        currLat = coordinates[i].location['latitude'];
        currLng = coordinates[i].location['longitude'];
        arrLat.push(currLat);
        arrLng.push(currLng);
        pathValues.push(currLat + ',' + currLng);
    }

    var coordinateChunks = spliceIntoChunks(pathValues, 100);
    for(var j = 0; j < coordinateChunks.length; j++) {
        getLinesFromApi(coordinateChunks[j], j);
    }

    centerMap(Math.min.apply(Math, arrLat), Math.max.apply(Math, arrLat), Math.min.apply(Math, arrLng), Math.max.apply(Math, arrLng));
    addStartAndStopMarkers(coordinates[0].location, coordinates[coordinates.length - 1].location);
    if (!Array.isArray(cachedApiResponse) || cachedApiResponse.length === 0 || cachedApiResponse[0].batch_number !== 0) {
        const apiCacheInterval = setInterval(function () {
            if (state.apiRequests > 0 && state.apiRequests === state.apiRequestsCompleted) {
                clearInterval(apiCacheInterval);

                for (var k = 0; k < state.snapMapApiResponse.length; k++) {
                    processSnapToRoadResponse(state.snapMapApiResponse[k]);
                    drawSnappedPolyline();
                }

                let startingBatchNumber = cachedApiResponse.length > 0 ? cachedApiResponse[0].batch_number : state.snapMapApiResponse.length;
                cacheApiResponse(startingBatchNumber - 1);
            }

        }, 10);
    }
}

function drawCachedRoadsResponse (batchLocations) {
    const arrLat = [];
    const arrLng = [];
    state.snapMapApiResponse = [];
    batchLocations.map(function (batch) {
        batch.data.map(function (cachedLocation) {
            arrLat.push(Number(cachedLocation.lat))
            arrLng.push(Number(cachedLocation.lng))
            state.snapMapApiResponse.push({
                location: {
                    latitude: Number(cachedLocation.lat),
                    longitude: Number(cachedLocation.lng),
                }
            });
        })
    })

    centerMap(Math.min.apply(Math, arrLat), Math.max.apply(Math, arrLat), Math.min.apply(Math, arrLng), Math.max.apply(Math, arrLng));
    processSnapToRoadResponse(state.snapMapApiResponse);
    drawSnappedPolyline();

    const startPos = batchLocations.slice(0, 1)[0].data.slice(0, 1)[0];
    const endPos = batchLocations.slice(-1)[0].data.slice(-1)[0];
    addStartAndStopMarkers({ longitude: startPos.lng, latitude: startPos.lat}, { longitude: endPos.lng, latitude: endPos.lat});
}

function spliceIntoChunks(arr, chunkSize) {
    var res = [];
    while (arr.length > 0) {
        var chunk = arr.splice(0, chunkSize - 1);
        if (arr.length > 0) {
            chunk.push(arr[0]);
        }
        res.push(chunk);
    }
    return res;
}

async function centerMap(minLat, maxLat, minLng, maxLng) {
    const { LatLngBounds, LatLng } = await google.maps.importLibrary("core");
    var bounds = new LatLngBounds(
        new LatLng(minLat, minLng),
        new LatLng(maxLat, maxLng)
    )

    map.fitBounds(bounds, 75);
}

async function addStartAndStopMarkers(start, stop) {
    const { PinElement, AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const startPos = {lat: parseFloat(start.latitude), lng: parseFloat(start.longitude)};
    const stopPos = {lat: parseFloat(stop.latitude), lng: parseFloat(stop.longitude)};
    const startPin = new PinElement({
        background: '#FFFFFF',
        borderColor: '#000000',
        glyphColor: '#000000',
        glyph: '►',
    })
    const endPin = new PinElement({
        background: '#FFFFFF',
        borderColor: '#000000',
        glyphColor: '#000000',
        glyph: '⏹︎',
    })

    // StartMarker
    new AdvancedMarkerElement({
        position: startPos,
        title: "Start",
        map: map,
        content: startPin.element
    })
    // EndMarker
    new AdvancedMarkerElement({
        position: stopPos,
        title: "Slutt",
        map: map,
        content: endPin.element,
    })
}

function deleteRoute() {
    if (state.isDeleting) {
        return;
    }
    state.isDeleting = true;

    Api.Delete(state.route.id).then(() => {
        window.location ='/practice';
    });
}

function getErrorMessage() {
    return state.errorMessage
}

export default {
    state,
    init,
    getRoute,
    isLoading,
    isDeleting,
    isMapLoading,
    initMap,
    deleteRoute,
    getErrorMessage,
}